export * from './mbr-retrieve-names-page.component';
